
import React from 'react';
import { RefreshCw } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PullToRefreshIndicatorProps {
  isVisible: boolean;
  isRefreshing: boolean;
  pullDistance: number;
  threshold?: number;
}

const PullToRefreshIndicator = ({
  isVisible,
  isRefreshing,
  pullDistance,
  threshold = 100,
}: PullToRefreshIndicatorProps) => {
  const progress = Math.min(pullDistance / threshold, 1);
  const shouldTrigger = pullDistance >= threshold;

  if (!isVisible) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 flex justify-center pt-4 transition-transform duration-200"
      style={{
        transform: `translateY(${Math.min(pullDistance * 0.3, 60)}px)`,
      }}
    >
      <div className="bg-background/90 backdrop-blur-sm border rounded-full p-3 shadow-lg">
        <RefreshCw
          className={cn(
            "h-5 w-5 transition-all duration-200",
            isRefreshing ? "animate-spin text-primary" : "text-muted-foreground",
            shouldTrigger && !isRefreshing && "text-primary scale-110"
          )}
          style={{
            transform: `rotate(${progress * 180}deg)`,
          }}
        />
      </div>
    </div>
  );
};

export default PullToRefreshIndicator;
